module.exports = __webpack_public_path__ + "img/AdddeviceWiZApp11.863e85a6.png";